<template>
  <!-- <export-excel
    type="csv"
    class="export_btn"
    :name="`HE activity list (${$route.params.month}/${$route.params.year}).xls`"
    :fields="custom_fields"
    :fetch="getData"
    :footer="[`${$route.params.month}/${$route.params.year}`]"
  >
    <v-icon color="white" left>mdi-chevron-right-circle-outline</v-icon>Export
  </export-excel> -->

  <v-btn
          @click="exportData"
            color="teal accent-4"
            depressed
            dark
            class="mb-1 mr-3"
          >
  <v-icon color="white" left>mdi-chevron-right-circle-outline</v-icon> Export
  </v-btn>
</template>

<script>
export default {
  props: {
    heData: {
      type: Array,
    },
  },
  computed: {},
  data: () => ({
    custom_fields: {
      Date: "date",
      Place: "place",
      Township:{
        field:'township',
        callback:(v) => v.name
      },
      "Township Group":{
        field:'township',
        callback: (value) => {
          const townshipGroupId = typeof value.township_group_id === 'string' ? Number( value.township_group_id) : value.township_group_id
          return townshipGroupId === 1 ? "MDR 1" :townshipGroupId == 2 ? "MDR 2" : '';
        },
      },
      Type: {
        field: "data",
        callback: (value) => {
          return value == 1 ? "community" : value == 2 ? "contact" : '';
        },
      },
      " Index Case no": "index_case_no",
      " Index Case year": "index_case_year",
      Screening_Person: {
        field: "screening_person",
        callback: (value) => {
          return value == 1 ? "Vol" : value == 2 ? "FO" : '';
        },
      },
      Volunteer: "volunteer.name",
      "Attendence Male": "n_o_attendence_male",
      "Attendence Female": "n_o_attendence_female",
      "Household Male": "n_o_household_male",
      "Household Female": "n_o_household_female",
      "Close Contact Male": "n_o_closecontact_male",
      "Close Contact Female": "n_o_closecontact_female",
      Remark: "remark",
    },
  }),

  methods: {
    exportData(){
      let data = {
        month:this.$route.params.month,
        year:this.$route.params.year,
        township_id: this.$route.query.township,
      }
   
      this.$store.dispatch("HE/exportHE", data);
    },
    getData() {
      if (this.heData.length > 0) return this.heData;
    },
  },
};
</script>

<style scoped>
.export_btn {
  background: #ff4081;
  border-radius: 3px;
  color: white !important;
  letter-spacing: 1px;
  text-transform: uppercase;
  width: 150px;
  padding: 5px 15px;
  margin-bottom: 1px;
  cursor: pointer;
}
</style>
